import React, { FC } from 'react';
import { Box } from '@mui/material';
import AddPhone from '../components/LoginScreenComponents/AddPhone';

const PatchPhone: FC = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingY: '10vh' }}>
          <AddPhone />
        </Box>
      </Box>
    </Box>
  );
};

export default PatchPhone;
